import { FunctionComponent, useEffect, useState } from "react"
import { Alert, Col, Container, Form, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate, useParams } from "react-router-dom"
import { Agreement, RouterExtended } from "../data/models"
import useLazyQuery from "../hooks/useLazyQuery"
import useQuery from "../hooks/useQuery"
import DateUtils from "../utils/DateUtils"

interface IChangeEndPage {}
const ChangeEndPage: FunctionComponent<IChangeEndPage> = () => {
	const yesterday = DateUtils.addDays(new Date(), -1)!.toISOString().substring(0, 10)
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const [date, setDate] = useState<string>("")
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	const router = routerQuery.data?.routers?.[0]
	const currentAgreementUrl = `${process.env.REACT_APP_KNIT_URL}agreements/${router?.currentAgreementId}`
	const patchCurrentAgreementQuery = useLazyQuery<Partial<Agreement>, any>(currentAgreementUrl, "PATCH")
	//set default date to currentEndDate
	useEffect(() => {
		if (!date && router?.currentEndDate) setDate(router?.currentEndDate)
	}, [date, router?.currentEndDate])
	//change end date function
	const changeEnd = async () => {
		await patchCurrentAgreementQuery.query({ body: { endDate: date } })
		navigate(-1)
	}
	//
	const error = patchCurrentAgreementQuery.error || routerQuery.error
	//
	if (!routerQuery.data) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Change End of Internet Service</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Change End of Internet Service</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">
				Change end of internet service for {router?.propertyName} {router?.unitName} to the following date?
			</div>
			<Form.Group className="mb-3" controlId="date">
				<Form.Label>Last Day of Service</Form.Label>
				<Form.Control type="date" required min={yesterday} max={getMaxEndDate(router?.nextStartDate)} value={date} onChange={(e) => setDate(e.target.value)} />
			</Form.Group>
			<Row className="mt-4">
				<Col xs="auto">
					<Button variant="secondary" disabled={patchCurrentAgreementQuery.loading} onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={patchCurrentAgreementQuery.loading || !!error} onClick={changeEnd}>
						{patchCurrentAgreementQuery.loading ? "Saving" : "Confirm"}
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default ChangeEndPage

interface RouterQueryResponse {
	routers: RouterExtended[]
}

const getMaxEndDate = (nextStartDate?: string) => {
	if (nextStartDate == null) return undefined
	return DateUtils.addDays(new Date(nextStartDate), -1)!.toISOString().substring(0, 10)
}
